export default __webpack_public_path__ + "static/media/pgmico(29).82500402.png";